import React, { useEffect, useRef, useState } from 'react';
import { CloseOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Divider, Input, InputNumber, Row, Select } from 'antd';
import Editor from '../Editor';
import axios from '../../utils/axios';

export default function About({ Form }) {
	const editor = useRef();

	return (
		<Row gutter={[16, 0]}>
			<Col sm={24} md={24}>
				<Form.Item name='about'>
					<Editor ref={editor} Form={Form} />
				</Form.Item>
				{/* <Form.Item
            label=" About Us"
            name="about"
            rules={[
              {
                required: true,
                message: ' Current Password is required',
              },
            ]}
          >
            <Input type="password" autoFocus />
          </Form.Item> */}
			</Col>
			<Col sm={24} md={24}>
				<Form.Item label='Address' name='address'>
					<Input.TextArea maxLength={5000} style={{ width: '100%' }} rows={4} />
				</Form.Item>
			</Col>
			<Col sm={24} md={24}>
				<Form.Item
					label='Location Link for iframe'
					rules={[
						{
							required: true,
							message: 'URL is required',
						},
					]}
					name='addressLink'
				>
					<Input style={{ width: '100%' }} placeholder='https://www.google.com/maps' />
				</Form.Item>
			</Col>
		</Row>
	);
}
